import { Component, h, Prop } from "@stencil/core";
import { BreadcrumbsProps } from "./f-breadcrumbs-model";
import config from "../../../../environment/environment-config";

@Component({
  tag: "f-breadcrumbs",
  styleUrl: "f-breadcrumbs.scss",
  shadow: true,
})
export class Breadcrumbs {
  @Prop() type: BreadcrumbsProps["type"] = "ol";
  @Prop({ mutable: true }) firstElement: BreadcrumbsProps["firstElement"];
  @Prop({ mutable: true }) elements: BreadcrumbsProps["elements"] = [];
  @Prop() useContextPath: BreadcrumbsProps["useContextPath"] = true;

  componentWillLoad() {
    if (typeof this.elements === "string") {
      this.elements = JSON.parse(this.elements);
    }
    if (typeof this.firstElement === "string") {
      this.firstElement = JSON.parse(this.firstElement);
    }
  }

  private generatePath = (el) =>
    this.useContextPath && el.url !== "#"
      ? config.navContextPath + el.url
      : el.url;

  render() {
    const CustomTag = this.type;
    const wrapperClass = "o-breadcrumbs";

    return (
      <CustomTag class={wrapperClass} data-test="breadcrumbs-wrapper">
        {this.firstElement && typeof this.firstElement !== "string" ? (
          <li
            class={{
              [`${wrapperClass}__item--item`]: true,
              [`${wrapperClass}__item--prev`]: this.elements?.length !== 0,
              [`${wrapperClass}__item--current`]: this.elements?.length === 0,
            }}
            data-test="breadcrumbs-first-item"
          >
            <a
              class={`${wrapperClass}__link`}
              href={this.generatePath(this.firstElement)}
              data-test="breadcrumbs-first-item-link"
            >
              {this.firstElement.name}
            </a>
          </li>
        ) : (
          ""
        )}
        {typeof this.elements !== "string" &&
          this.elements?.map((element, index) => {
            return (
              <li
                class={{
                  [`${wrapperClass}__item--item`]: true,
                  [`${wrapperClass}__item--prev`]:
                    index + 1 !== this.elements.length,
                  [`${wrapperClass}__item--current`]:
                    index + 1 === this.elements.length,
                }}
                data-test="breadcrumbs-item"
              >
                <a
                  class={`${wrapperClass}__link`}
                  href={this.generatePath(element)}
                  data-test="breadcrumbs-item-link"
                  aria-current={{ page: index + 1 === this.elements.length }}
                >
                  {element.name}
                </a>
              </li>
            );
          })}
      </CustomTag>
    );
  }
}
